<template>
  <svg
  class="download"
    id="Calque_1"
    data-name="Calque 1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 85.86 83.88"
  >
    <defs>
      <linearGradient
        id="Dégradé_sans_nom_20"
        x1="-130.08"
        y1="46.17"
        x2="112.73"
        y2="35.45"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.24" stop-color="#f2e733"></stop>
        <stop offset="0.34" stop-color="#f2df37"></stop>
        <stop offset="0.45" stop-color="#f1c832"></stop>
        <stop offset="0.6" stop-color="#f0a433"></stop>
        <stop offset="0.79" stop-color="#ee7431"></stop>
      </linearGradient>

      <linearGradient
        id="degrade_active"
        x1="-130.08"
        y1="46.17"
        x2="112.73"
        y2="35.45"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#51b3e3"></stop>
        <stop offset="1" stop-color="#83c06f"></stop>
      </linearGradient>


      <linearGradient
        id="Dégradé_sans_nom_20-2"
        x1="-129.29"
        y1="63.99"
        x2="113.52"
        y2="53.27"
        xlink:href="#Dégradé_sans_nom_20"
      ></linearGradient>
      <linearGradient
        id="Dégradé_sans_nom_20-3"
        x1="3.08"
        y1="57.18"
        x2="111.08"
        y2="61.01"
        xlink:href="#Dégradé_sans_nom_20"
      ></linearGradient>
    </defs>
    <title>{{title}}</title>

    <polygon
      fill="url('#Dégradé_sans_nom_20')"
      class="cls-1"
      points="44.01 48.48 46.2 22.52 39.56 22.52 41.85 48.48 32.86 41.94 37.89 48.32 42.93 54.69 47.97 48.32 53.01 41.94 44.01 48.48"
    ></polygon>
    <polygon
      fill="url('#degrade_active')"
      class="cls-1 hover"
      :class="{active}"
      points="44.01 48.48 46.2 22.52 39.56 22.52 41.85 48.48 32.86 41.94 37.89 48.32 42.93 54.69 47.97 48.32 53.01 41.94 44.01 48.48"
    ></polygon>


    <polygon
      fill="url('#Dégradé_sans_nom_20-2')"
      class="cls-2"
      points="56.24 51.41 56.24 57.05 29.62 57.05 29.62 51.41 25.67 51.41 25.67 61.35 60.19 61.35 60.19 51.41 56.24 51.41"
    ></polygon>
    <polygon
      fill="url('#degrade_active')"
      class="cls-2 hover"
      :class="{active}"
      points="56.24 51.41 56.24 57.05 29.62 57.05 29.62 51.41 25.67 51.41 25.67 61.35 60.19 61.35 60.19 51.41 56.24 51.41"
    ></polygon>


    <path
      fill="url('#Dégradé_sans_nom_20-3')"
      class="cls-3"
      d="M100,34.4l-26.58-13-8.14-4-2.23,1.1L36.15,31.69l-7.68,3.75-6.09,3v42l8.14,4h0l26.56,13,8.21,4,2.84-1.38L95.08,86.79l6.94-3.4,6.22-3V38.41Zm5.38,44-.57.83L92.24,85.4,65.31,98.55l-6.79-3.32L32,82.26,25.21,79V40.2l.42-.61h0L39,33.07,65.31,20.21l6.74,3.29,26.57,13,6.79,3.32Z"
      transform="translate(-22.38 -17.44)"
    ></path>
    <path
      fill="url('#degrade_active')"
      class="cls-3 hover"
      :class="{active}"
      d="M100,34.4l-26.58-13-8.14-4-2.23,1.1L36.15,31.69l-7.68,3.75-6.09,3v42l8.14,4h0l26.56,13,8.21,4,2.84-1.38L95.08,86.79l6.94-3.4,6.22-3V38.41Zm5.38,44-.57.83L92.24,85.4,65.31,98.55l-6.79-3.32L32,82.26,25.21,79V40.2l.42-.61h0L39,33.07,65.31,20.21l6.74,3.29,26.57,13,6.79,3.32Z"
      transform="translate(-22.38 -17.44)"
    ></path>

  </svg>
</template>
<script>
export default {
  props: {
    title: String,
    active: Boolean
  },
}
</script>

<style lang="sass" scoped>
svg:hover .hover, svg .active
  opacity: 1 !important
svg .hover
  opacity: 0.0
  transition: opacity .4s ease
</style>
